import { ExportConfiguration } from '../export/exportConfiguration';
import { ExportType } from '../export/export';
import { translate } from '../translation/Translator';
import { TranslationKey } from '../translation/TranslationKey';
import { TranslationLanguage } from '../translation/translation';

export const ProductExportConfigurationField = {
  productName: 'productName',
  productNumber: 'productNumber',

  stockLocation: 'stockLocation',
  binName: 'binName',

  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',

  globalTradeItemNumber: 'globalTradeItemNumber',
  lpn: 'lpn',
  serialNumber: 'serialNumber',
  quantity: 'quantity',

  lotNumber: 'lotNumber',
  expirationDate: 'expirationDate',

  containerIdentifier: 'containerIdentifier',
  containerType: 'containerType',

  unitOfMeasure: 'unitOfMeasure',

  purchasePrice: 'purchasePrice',
  sellingPrice: 'sellingPrice',
  totalPurchasePrice: 'totalPurchasePrice',
  totalSellingPrice: 'totalSellingPrice',
} as const;

export type ProductExportConfigurationField =
  (typeof ProductExportConfigurationField)[keyof typeof ProductExportConfigurationField];

export class ProductExportConfiguration extends ExportConfiguration<ProductExportConfigurationField> {
  static default(companyId: string, language?: TranslationLanguage) {
    return new ProductExportConfiguration({
      companyId,
      name: '',
      type: ExportType.xlsx,
      filename: 'ventory_products_${TIMESTAMP}',
      mapping: new Map([
        [
          ProductExportConfigurationField.stockLocation,
          { value: translate({ key: TranslationKey.stockLocation, language }), index: 0 },
        ],
        [
          ProductExportConfigurationField.productName,
          { value: translate({ key: TranslationKey.productName, language }), index: 1 },
        ],
        [
          ProductExportConfigurationField.productNumber,
          { value: translate({ key: TranslationKey.productNumber, language }), index: 2 },
        ],
        [
          ProductExportConfigurationField.binName,
          { value: translate({ key: TranslationKey.binName, language }), index: 3 },
        ],
        [
          ProductExportConfigurationField.quantity,
          { value: translate({ key: TranslationKey.quantity, language }), index: 4 },
        ],
      ]),
    });
  }
}
